import React from 'react'

import LoadingIndicator from 'components/LoadingIndicator'
import { Snackbar } from 'components/Snackbar'
import { DeliveryLinkageFeatureOffNotice } from 'components/DeliveryLinkageFeatureOffNotice'
import { formatPhoneNumber } from 'utils/formatPhoneNumber'
import { ShipmentStatusChip } from 'containers/DeliveryPerformanceList/components/ShipmentStatusChip'

import type { DeliveryPerformanceDetailControllerReturn } from '../hooks/useDeliveryPerformanceDetailController'
import { ShipmentBookingSection } from './ShipmentBookingSection'
import { VisitSection } from './VisitSection'
import styles from '../style.module.css'

type Props = DeliveryPerformanceDetailControllerReturn

export const DeliveryPerformanceDetailView: React.FC<Props> = ({
  shipment,
  masterData,
  isLoading,
  isError,
  isFeatureOff,
  handleBack,
  handleDownloadAttachment,
  snackbar,
}) => {
  if (isLoading) {
    return (
      <div className={styles.page}>
        <div className={styles.centerState}>
          <LoadingIndicator />
        </div>
      </div>
    )
  }

  // 区分 OFF テナントが詳細 URL を直接開いたときは案内表示のみ（詳細本体は出さない）
  if (isFeatureOff) {
    return (
      <div className={styles.page}>
        <DeliveryLinkageFeatureOffNotice />
      </div>
    )
  }

  if (isError || shipment == null) {
    return (
      <div className={styles.page}>
        <div className={styles.errorState}>読み込みに失敗しました</div>
      </div>
    )
  }

  const sortedVisits = [...shipment.visits].sort((a, b) => a.sequenceOrder - b.sequenceOrder)

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        {/* ページヘッダー */}
        <div className={styles.pageHeader}>
          <div className={styles.headingLeft}>
            <h1 className={styles.title}>納品実績詳細</h1>
            <div className={styles.driverPhoneGroup}>
              <span className={styles.driverPhoneLabel}>ドライバー電話番号</span>
              <span className={styles.driverPhoneValue}>
                {formatPhoneNumber(shipment.driverPhone)}
              </span>
            </div>
          </div>
          <ShipmentStatusChip status={shipment.status} />
        </div>

        {/* セクション群 */}
        <div className={styles.sections}>
          <ShipmentBookingSection pickBooking={shipment.pickBooking} masterData={masterData} />
          {sortedVisits.map((visit, index) => (
            <VisitSection
              key={visit.id}
              visit={visit}
              index={index}
              shipmentId={shipment.id}
              onDownloadAttachment={handleDownloadAttachment}
            />
          ))}
        </div>

        {/* 戻る */}
        <div className={styles.footer}>
          <button type="button" className={styles.backButton} onClick={handleBack}>
            戻る
          </button>
        </div>
      </div>
      <Snackbar {...snackbar} />
    </div>
  )
}
